import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { getTranslation } from '@shared/translate-helper';

@Pipe({
  name: 'safeTruncate',
  standalone: false,
})
export class SafeTruncatePipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
  ) {}

  transform(value: string, limit: number): SafeHtml {
    if (!value) {
      return '';
    }

    let parser = new DOMParser();
    let parsedHtml = parser.parseFromString(value, 'text/html');
    let textContent = parsedHtml.body.textContent || '';
    let showMoreElement = document.createElement('span');
    showMoreElement.classList.add('cursor-pointer', 'show_more_text');

    if (limit >= 0 && textContent.length > limit) {
      let truncatedText = textContent.slice(0, limit) + '...';
      getTranslation(this.translateService, 'more').subscribe((t: any) => {
        showMoreElement.textContent = t;
      });
      parsedHtml.body.textContent = truncatedText;
      parsedHtml.body.appendChild(showMoreElement);
      return this.sanitizer.bypassSecurityTrustHtml(parsedHtml.body.innerHTML);
    }

    // Show 'less' text when the user clicks on 'more' text
    if (textContent && textContent.length > limit) {
      getTranslation(this.translateService, 'less').subscribe((t: any) => {
        showMoreElement.textContent = `  ` + t;
      });
      parsedHtml.body.appendChild(showMoreElement);
      return this.sanitizer.bypassSecurityTrustHtml(parsedHtml.body.innerHTML);
    }

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
